import FooterText from "../Footer/Footer";
import { useNavigate } from "react-router-dom";
import LeftPanel from "../LeftPanel/LeftPanel";
import { useEffect, useContext } from "react";
import { MyContext } from "../../MyContext";

const TermsConditions = () => {
  const { onPage, setOnPage } = useContext(MyContext)!;
  useEffect(() => {
    setOnPage(window.location.pathname.substring(1));
  }, []);

  return (
    <>
      <div className="mobile-pro">
        <div className="login">
          <img src="img/issue-icon-default.svg" />
          <h2>Terms & Conditions</h2>
        </div>
      </div>
    </>
  );
};

export default TermsConditions;
